import useMediaQuery from '../../../../hooks/useMediaQuery'
import { EcosystemMobile } from './mobile/mobile'
import { EcosystemDesktop } from './desktop/desktop'

export const Ecosystem = () => {
  const mediaQuery = useMediaQuery('(max-width: 767px)')

  return mediaQuery ? <EcosystemMobile /> : <EcosystemDesktop />
}
